import React from 'react';
import { motion } from 'framer-motion';

const nodes = [
    { x: 60, y: 60 }, { x: 220, y: 40 }, { x: 340, y: 140 },
    { x: 120, y: 200 }, { x: 300, y: 280 }, { x: 80, y: 320 },
];

const edges: [number, number][] = [
    [0, 1], [1, 2], [0, 3], [3, 4], [3, 5], [1, 4],
];

const HeroVisual = () => (
    <svg viewBox="0 0 400 400" width="100%" height="100%" style={{ maxWidth: 420 }}>
        <motion.g
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        >
            {edges.map(([a, b], i) => (
                <motion.line
                    key={i}
                    x1={nodes[a].x}
                    y1={nodes[a].y}
                    x2={nodes[b].x}
                    y2={nodes[b].y}
                    stroke="rgba(245,245,242,0.25)"
                    strokeWidth={1}
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 1, delay: 0.3 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                />
            ))}
            {nodes.map((n, i) => (
                <motion.circle
                    key={i}
                    cx={n.x}
                    cy={n.y}
                    r={i === 3 ? 6 : 4}
                    fill={i === 3 ? '#7C8CFF' : '#F5F5F2'}
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.8 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                />
            ))}
        </motion.g>
    </svg>
);

export default HeroVisual;
